import React from 'react';
import parse from 'html-react-parser';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {}
        };

        this.load = this.load.bind(this);
    }

    load(e) {
        // Callers that carry request-scoped print data (for example cash
        // received/change) must not reload the voucher before React has
        // committed that exact HTML and started the print callback.
        return new Promise((resolve, reject) => {
            this.setState({ data: e }, async () => {
                try {
                    await this.props.onReady?.();
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        });
    }

    render() {
        if (!this.state.data || !this.state.data.html)
            return (
                <React.Fragment>
                    <div></div>
                </React.Fragment>
            );

        return (
            <React.Fragment>
                <div>{parse(this.state.data.html)}</div>
            </React.Fragment>
        );
    }
}
